export const FOOTER_CONTENT = 'footer-content';
